// extracted by mini-css-extract-plugin
export default {"tabItem":"h1Oz6","active":"O0eO0","disabled":"VqOnb"};